import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/discovery/DiscoverySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/fancy-carousel/FancyCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/home/AwardsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/home/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/home/HeroBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/new-vehicle-promotion/NewVehiclePromotion.tsx");
